import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, shareReplay, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { DownloadLifeInsuranceBeneficiaryReportCommandResponse } from "../../models/employee-benefit/employee-benefit.response";
import { DownloadLifeInsuranceBeneficiaryReportCommandRequest } from "../../models/employee-benefit/employee-benefit.request";
import { AppToastService } from "../app-toast.service";
import { Router } from "@angular/router";
import { ResponseTemplate } from "../../models/account/api.common";

@Injectable({
  providedIn: "root",
})
export class PersonalDataService {
  baseUrlApi = environment.url;

  $lifeInsuranceBenefitReportHTML = new Subject<string>();

  constructor(
    private http: HttpClient,
    private toast: AppToastService,
    private router: Router
  ) {}

  getGeneralData(id) {
    const endpoint = `${this.baseUrlApi}/v1/employees/${id}/personal-data`;
    return this.http.get(endpoint);
  }

  postGeneralData(id, body) {
    const endpoint = `${this.baseUrlApi}/v1/employees/${id}/personal-data`;
    return this.http.post(endpoint, body);
  }

  putGeneralData(id, body) {
    const endpoint = `${this.baseUrlApi}/v1/employees/${id}/personal-data`;
    return this.http.put(endpoint, body);
  }

  getBankList(): Observable<any> {
    return this.http.get(`${this.baseUrlApi}/v1/banks`).pipe(shareReplay());
  }

  getBenefits(id): any {
    const endpoint = `${this.baseUrlApi}/v1/employees/${id}/benefits`;
    return this.http.get(endpoint);
  }

  postBenefits(id, payload): any {
    const endpoint = `${this.baseUrlApi}/v1/employees/${id}/benefits`;
    return this.http.post(endpoint, payload);
  }

  downloadLifeInsuranceBenefitReportHTML(
    req: DownloadLifeInsuranceBeneficiaryReportCommandRequest
  ) {
    const endpoint = `${this.baseUrlApi}/v1/employees/${req.employeeId}/benefits/life-insurance-beneficiaries/export`;

    return this.http
      .get<
        ResponseTemplate<DownloadLifeInsuranceBeneficiaryReportCommandResponse>
      >(endpoint)
      .pipe(
        map((response) => {
          if (!response.data) return "";

          const html = atob(
            response.data.base64String
              .replace(/\s+/g, "")
              .replace(/-/g, "+")
              .replace(/_/g, "/")
          );

          const decodedHtml = new TextDecoder("utf-8").decode(
            new Uint8Array(Array.from(html, (char) => char.charCodeAt(0)))
          );

          return decodedHtml;
        })
      )
      .subscribe((html) => this.$lifeInsuranceBenefitReportHTML.next(html));
  }
}
